const Swal = require('sweetalert2');
const $ = require("jquery");
SubmitForm = {
    init() {
        $('body').on('submit', 'form.form-ajax-send', e => {
            const form = e.currentTarget;
            const $this = this;
            let button = form.querySelector('[type="submit"].focus');
            if (e.originalEvent && e.originalEvent.submitter) {
                button = e.originalEvent.submitter;
                // this.disableSubmitButton(button);
            }

            if (button && button.dataset.timeout && button.dataset.timeout > 0) {
                setTimeout(function () {
                    $this.makeRequest(form, button);
                }, button.dataset.timeout);
            } else {
                $this.makeRequest(form, button);
            }
            e.preventDefault();
        });

        $('body').on('click', 'button', e => {
            $('body').find('button').removeClass('focus');
            e.currentTarget.classList.add('focus');
        });
    },

    getCookie(cookieName) {
        var name = cookieName + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var cookieArray = decodedCookie.split(';');
        for (var i = 0; i < cookieArray.length; i++) {
            var cookie = cookieArray[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return "";
    },

    disableSubmitButton(button) {
        if (button) {
            button.setAttribute('disabled', '');
            button.classList.add('disabled');
            this.saveButtonInner = button.innerHTML;
            button.innerHTML = '<i class="fa spinner-border spinner-border-sm mt-1 mb-1 fa-spin"></i>';
        }
    },

    enableSubmitButton(button) {
        if (button) {
            button.removeAttribute('disabled');
            button.classList.remove('disabled');
        }
    },

    dispatchAfterFormSubmittedEvent(item, data) {
        const event = new CustomEvent('forms:submitted', {
            detail: data
        });

        document.dispatchEvent(event);
        document.body.dispatchEvent(event);
        item.dispatchEvent(event);
    },

    removeSpinner(button) {
        if (button && button.querySelector('.fa-spin')) {
            button.innerHTML = this.saveButtonInner;
        }
    },

    makeRequest(form, button, params = {}) {
        let error = {};
        const formData = new FormData(form);
        //durzecenie parametrow
        for (let key in params) {
            formData.append(key, params[key]);
        }
        const modal = form.closest('.modal');
        formData.append('_method', form.querySelector('[name="_method"]') ? 'PATCH' : 'POST');
        if (button && button.hasAttribute('name')) {
            formData.append('btn_name', button.getAttribute('name'));
        }

        const requestId = Math.random().toString(36).slice(-5);
        AjaxLoader.addLoader(requestId);
        $(form).find('.invalid-feedback').remove();
        $(form).find('.is-invalid').removeClass('is-invalid');
        $(form).find('.bxs-error').remove();

        $.ajax({
            url: form.action,
            type: form.method,
            dataType: 'json',
            data: formData,
            processData: false,
            contentType: false,
            success: (d) => {
                AjaxLoader.removeLoader(requestId);

                if (d.message) {
                    Swal.fire(
                        {
                            title: 'Wysłany formularz',
                            text: d.message,
                            type: 'success',
                            timer: 3000
                        }
                    )

                    try {
                        formData.append('utm_source', SubmitForm.getCookie("utmSource"));
                        formData.append('utm_medium', SubmitForm.getCookie("utmMedium"));
                        formData.append('utm_compaign', SubmitForm.getCookie("utmCampaign"));
                        formData.append('event', 'formSubmit');
                        window.dataLayer = window.dataLayer || [];
                        const objectFormData = {};
                        formData.forEach(function (value, key) {
                            objectFormData[key] = value;
                        });
                        const jsonFormData = JSON.parse(JSON.stringify(objectFormData));
                        console.log(jsonFormData);
                        dataLayer.push(jsonFormData);
                    } catch (error) {
                        console.log(error);
                    }
                }


                this.enableSubmitButton(button);
                this.removeSpinner(button);

                const replaceContainer = form.getAttribute('data-replace-element');
                const replaceElement = document.querySelector('[' + replaceContainer + ']');
                if (replaceElement && d[replaceContainer]) {
                    replaceElement.outerHTML = d[replaceContainer];
                    app.runInitScripts(document.querySelector('[' + replaceContainer + ']'), '[' + replaceContainer + ']');
                    $(form).trigger('change');
                }

                if (d['redirect']) {
                    setTimeout(function () {
                        window.location.href = d['redirect'];
                    }, 1000);
                }

                if (d['reload']) {
                    setTimeout(function () {
                        $(form).find(':input').val('');
                        window.location.reload();
                    }, 1000);
                }

                if (button) {
                    const clearFields = button.getAttribute('data-clear-fields');
                    if (clearFields) {
                        $(clearFields).val('').trigger('change');
                    }
                }

                this.dispatchAfterFormSubmittedEvent(form, {
                    form: form,
                    button: button,
                    ...d
                });

                $(form).find('.close').click();
                // if ($(button).closest('.card')) {
                //     $(button).closest('.card').find('.EDataTable .btn_refresh').click();
                // }
                // $(form)[0].reset();
            },
            error: error => {
                AjaxLoader.removeLoader(requestId);
                if (error.responseJSON && error.responseJSON.data && error.responseJSON.data.errors) {
                    let errors = [];
                    Swal.fire(
                        {
                            title: 'Błąd formularza!',
                            text: 'Twój formularz posiada błędy.',
                            type: 'error',
                            timer: 3000
                        }
                    )
                    let navAddError = [];
                    let tableTd = [];
                    Object.entries(error.responseJSON.data.errors).forEach(([key, row]) => {
                        let strKey = '';
                        let strKey2 = '';
                        let temp = '';
                        findEl = undefined;
                        if (key.indexOf('.') > -1) {
                            let aKey = key.split('.');
                            if (aKey.length > 0) {
                                aKey.forEach(function (value, k) {
                                    if (k != 0) {

                                        strKey += '[' + value + ']';
                                    }
                                });
                                temp = aKey[0] + strKey;
                                strKey = ':input[name="' + temp + '"]';
                                strKey2 = ':input[name="' + temp + '[]"]';

                            }
                        } else {
                            strKey = ':input[name="' + key + '"]';
                            strKey2 = ':input[name="' + key + '[]"]';
                        }

                        if ($(strKey).length > 0) {
                            findEl = $(strKey);
                        } else if ($(strKey2).length > 0) {
                            findEl = $(strKey2);
                        }

                        const errorMsg = row[0];
                        const errorMsgHtml = '<span id="' + key + '-error" class="pl-1 invalid-feedback" style="display: block;">' + errorMsg + '</span>';
                        if (typeof findEl !== 'undefined' && findEl.length && findEl.attr('type') !== 'hidden') {

                            let parent = findEl.parents('label');
                            if (!parent.length) {
                                parent = findEl.parents('.form-group');
                            }
                            if (parent.length > 0) {
                                parent.find('.invalid-feedback').remove();
                                errors[key] = parent.append(errorMsgHtml);
                                parent.find(':input').addClass('is-invalid');
                            } else {
                                findEl.next('.invalid-feedback').remove();
                                errors[key] = findEl.after(errorMsgHtml);
                                findEl.addClass('is-invalid');
                            }
                            const tab = findEl.closest('.tab-pane');
                            const table = findEl.closest('table');
                            const td = findEl.closest('td');
                            if (table) {
                                const thead = table.find('thead');
                                const index = td.index();
                                if (thead && tableTd[index] != true) {
                                    thead.find('th:eq(' + index + ')').append('<i class=\'bi bi-error text-danger px-1\'></i>');
                                    tableTd[index] = true;
                                }
                            }
                            if (tab) {
                                const tabId = tab.attr('id');
                                const navTab = $(form).find('#' + tabId + 'Nav');
                                if (navTab && navAddError[tabId] != true) {
                                    navTab.find('button').append('<i class=\'bi bi-error text-danger px-1\'></i>');
                                    navAddError[tabId] = true;
                                }
                            }
                        }
                    });
                } else if (error.responseJSON.error) {
                    Notification.Error(error.responseJSON.error);
                    // form.reset();
                }

                this.enableSubmitButton(button);
                this.removeSpinner(button);

                return error;
            }
        });

        return error;
    },

    selectUnselect: function (src, parent) {
        const parentEl = $(src).closest(parent);
        if (parentEl) {
            if (parentEl.find('input[type="checkbox"]:checked').length == parentEl.find('input[type="checkbox"]').length) {
                parentEl.find('input[type="checkbox"]').prop('checked', false);
            } else {
                parentEl.find('input[type="checkbox"]').prop('checked', true);
            }
        }
    }
}
document.addEventListener('DOMContentLoaded', () => {
    select2Init();
    SubmitForm.init();
    $(document).ajaxStart(function () {
        AjaxLoader.addLoader('ajaxLoader123123');
    }).ajaxStop(function () {
        AjaxLoader.removeLoader('ajaxLoader123123');
    }).ajaxError(function (e, xhr, settings, exception) {
        AjaxLoader.removeLoader('ajaxLoader123123');
    });
});

let ajaxReplaceTarget = '';
let ajaxAfterScripts = '';
ajaxOpen = function (src) {
    sendAjax = function (src) {
        if (typeof src.attr('method') !== 'undefined') {
            var type = src.attr('method').toLowerCase();
        } else {
            var type = 'get';
        }

        var url = src.attr('href');
        if (typeof url === 'undefined') {
            url = src.attr('data-url');
        }

        ajaxReplaceTarget = src.data('replaceTarget') ?? '';
        ajaxAfterScripts = src.data('afterScripts') ?? '';

        var params = {};

        let passGET = '';
        $.each(src[0].attributes, function (i, v) {
            if (v.name.indexOf('parame-') > -1) {
                params[v.name.replace('parame-', '')] = eval(v.value);
                passGET += '&' + v.name.replace('parame-', '') + '=' + params[v.name.replace('parame-', '')];
            }
            if (v.name.indexOf('param-') > -1) {
                params[v.name.replace('param-', '')] = v.value;
                passGET += '&' + v.name.replace('param-', '') + '=' + v.value;
            }
        });
        params['_token'] = $('input[name="_token"]').val();
        let sendParams = {};
        if (type === 'get') {
            url += passGET;
        } else {
            sendParams = JSON.stringify(params);
        }

        $('#loading').show();
        $.ajax({
            url: url,
            type: type,
            data: sendParams,
            dataType: 'json',
            processData: true,
            contentType: 'application/json',
            complete: function (resp) {
                let jResponse = resp.responseJSON;
                checkResponse(jResponse, src);
            }
        });

    }

    var checkLength = src[0].dataset.checkLength;
    console.log($(checkLength).length);
    if (checkLength && !$(checkLength).length) {
        const checkLengthError = src[0].dataset.checkLengthError;
        Notification.Error(checkLengthError ?? 'Nie zaznaczono żadnego elementu.');
        return false;
    }

    var cfrm = src.attr('confirm');

    if (typeof cfrm !== "undefined" && cfrm !== '') {

        Swal.fire({
            title: cfrm,
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Tak',
            denyButtonText: 'Nie',
            cancelButtonText: 'Anuluj',
        }).then((result) => {
            if (result.isConfirmed) {
                sendAjax(src);
            } else if (result.isDenied) {
                next = false;
            }
        });
    } else {
        sendAjax(src);
    }

    return false;
};

UploadObject = {
    form: '',
    action: '',
    sendAjax: function (src) {
        src = $(src);
        this.form = src.parents('form');
        this.action = this.form.attr('action');
        if (this.form.find('input[name="files[]"]')[0].files.length === 0) {
            Notification.Warning(__('Proszę wybrać pliki!'));
            return false;
        } else {
            UploadObject.uploadData(this.form.find('input[name="files[]"]')[0].files);
        }

    },

    uploadData: function (file_obj) {
        if (file_obj != undefined) {
            var form_data = new FormData(this.form[0]);
            for (i = 0; i < file_obj.length; i++) {
                form_data.append('files[' + i + ']', file_obj[i]);
                if (file_obj[i].name.indexOf('.exe') > -1) {
                    Notification.Error(__('Niedopuszczalny format pliku ' + file_obj[i].name));
                    return false;
                }

                if (file_obj[i].size > 8988608) {
                    Notification.Error(__('Niedopuszczalny rozmiar pliku ' + file_obj[i].name));
                    return false;
                }

            }

            $.ajax({
                url: this.action,
                type: 'post',
                data: form_data,
                contentType: false,
                processData: false,
                dataType: 'html',
                complete: function (resp) {
                    let jResponse = JSON.parse(resp.responseText);
                    checkResponse(jResponse);
                }
            });
        }
    }
};

const checkResponse = function (jResponse, src) {
    try {
        if (jResponse.message) {
            if (jResponse.message.type === 'fail' || jResponse.message.type === 'error') {
                Notification.Error(jResponse.message.text);
            } else {
                Notification.Success(jResponse.message.text ?? jResponse.message);
                if (jResponse.reload) {
                    setTimeout(function () {
                        window.location.reload();
                    }, 1000);
                } else if (jResponse.redirect && jResponse.redirect !== '') {
                    setTimeout(function () {
                        window.location.href = jResponse.redirect;
                    }, 1000);
                }
            }
        } else if (jResponse.data && jResponse.data.errorsString) {
            let errors = [];
            Swal.fire(
                {
                    title: jResponse.data.message,
                    text: jResponse.data.errorsString,
                    type: 'error',
                    timer: 3000
                }
            )
            return false;
        } else if (jResponse.append && jResponse.append.html) {
            if (ajaxReplaceTarget !== '') {
                const target = $(ajaxReplaceTarget);
                if (target.length) {
                    target.html(jResponse.append.html);
                }
            } else {
                const target = $(jResponse.append.target);
                if (target.length) {
                    target.html(jResponse.append.html);
                }
            }

            if (ajaxAfterScripts !== '') {
                setTimeout(function () {

                    eval(ajaxAfterScripts + '()');
                }, 100);
            }
        } else if (jResponse.error) {
            Notification.Error(jResponse.error);
            if (jResponse.redirect && jResponse.redirect !== '') {
                setTimeout(function () {
                    window.location.href = jResponse.redirect;
                }, 1000);
            }
        }

    } catch (error) {
        refresh = false;
    }

    if (src && !$(src).hasClass('table-reload') && src.closest('.ajax-container')) {
        src.closest('.ajax-container').find('.table-reload').click();
    }

    return false;
}

Notification = {
    timeout: null,
    progressTime: null,
    progress: 0,
    Download: function (message) {
        Swal.fire(
            {
                title: 'Powiadomienie',
                text: message,
                type: 'info',
                showCancelButton: false,
                showConfirmButton: false
            }
        )
    },
    Push: function (type, message, delay = 3000) {
        Swal.fire(
            {
                title: 'Powiadomienie',
                text: message,
                type: type,
                timer: delay
            }
        )
    },
    Info: function (message, delay = 3000) {
        Swal.fire(
            {
                title: 'Info',
                text: message,
                type: 'info',
                timer: delay
            }
        )
    },
    Success: function (message, delay = 3000) {
        Swal.fire(
            {
                title: 'Sukces',
                text: message,
                type: 'success'
                // timer: delay
            }
        )
    },
    Error: function (message, delay = 3000) {
        Swal.fire(
            {
                title: 'Błąd',
                text: message,
                type: 'error',
                timer: delay
            }
        )
    },
    Warning: function (message, delay = 3000) {
        Swal.fire(
            {
                title: 'Ostrzeżenie',
                text: message,
                type: 'warning',
                timer: delay
            }
        )
    },
    confirmRedirect(msg, url) {
        Swal.fire({
            title: msg,
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Tak',
            denyButtonText: 'Nie',
            cancelButtonText: 'Anuluj',
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.href = url;
            }
        });

    }
};

AjaxLoader = {
    addLoader: function (id) {
        $('body').prepend('<div id="' + id + '" style="position:fixed; top:50%; left:50%; z-index:99999;">' +
            '<div class="spinner-border" role="status">' +
            '<span class="visually-hidden">Loading...</span>' +
            '</div>' +
            '</div>');
    },

    removeLoader: function (id) {
        $('#' + id).remove();
    }

}

select2Init = function () {
    if ($('.select2-ajax').length) {
        $('.select2-ajax').each(function () {
            const data_url = $(this).attr('data-url');
            let tags = false;
            if ($(this).hasClass('tags-enable')) {
                tags = true;
            }
            $(this).select2({
                theme: 'bootstrap-5',
                tags: tags,
                allowClear: true,
                placeholder: '--Wybierz--',
                language: 'pl',
                ajax: {
                    url: function () {
                        const serializeDiv = $(this).parents('.select2-to-serialize');
                        if (serializeDiv) {
                            const formSerialize = serializeDiv.find(':input').serialize();
                            return data_url + '&select2=1&' + formSerialize;
                        } else {
                            return data_url + '&select2=1&';
                        }
                    },

                    dataType: 'json'
                },
                createTag: function (params) {
                    var term = $.trim(params.term);

                    if (term === '') {
                        return null;
                    }

                    return {
                        id: term,
                        text: term
                    };
                },
            });
        });
    }

    if ($('.select2-simple').length) {
        $('.select2-simple').each(function () {

            let tags = false;
            if ($(this).hasClass('tags-enable')) {
                tags = true;
            }

            $(this).select2({
                theme: 'bootstrap-5',
                tags: tags,
                width: '100%',
                dropdownParent: $(this).parent(),
                language: 'pl'
            });
        });

    }
}
